import cn from 'bem-cn';

import { Stack } from '../Stack';
import { List } from '../List';
import { Icon } from '../Icon';

import { CarouselProps } from './Carousel.types';
import { useCarousel } from './Carousel.hooks';
import './Carousel.scss';

const b = cn('carousel');

export const Carousel = <T extends unknown>(props: CarouselProps<T>) => {
    const {
        className,
        items,
        renderItem,
        keyExtractor,
        isLoading,
        skeletonItems,
        renderSleketonItem,
        skeletonKeyExtractor,
    } = props;

    const { scrollContainerRef, canScrollLeft, canScrollRight, shouldCenter, handleScrollLeft, handleScrollRight } =
        useCarousel(items);

    return (
        <Stack className={b.mix(className)}>
            <Stack className={b('chevron-container', { position: 'left', hidden: !canScrollLeft })}>
                <Stack className={b('chevron')} onClick={handleScrollLeft}>
                    <Icon name="backArrow" />
                </Stack>
            </Stack>
            <div
                ref={scrollContainerRef}
                className={b('scroll-container', {
                    'should-center': shouldCenter,
                })}
            >
                {isLoading && skeletonKeyExtractor && renderSleketonItem ? (
                    <List
                        className={b('list')}
                        direction="row"
                        items={(skeletonItems as never[]) || []}
                        renderItem={renderSleketonItem}
                        keyExtractor={skeletonKeyExtractor}
                    />
                ) : (
                    <List
                        className={b('list')}
                        direction="row"
                        items={items}
                        renderItem={renderItem}
                        keyExtractor={keyExtractor}
                    />
                )}
            </div>
            <Stack className={b('chevron-container', { position: 'right', hidden: !canScrollRight })}>
                <Stack className={b('chevron')} onClick={handleScrollRight}>
                    <Icon name="chevronRight" />
                </Stack>
            </Stack>
        </Stack>
    );
};
